const rippleEffectDuration = 2000;

let toastifyConfigs = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
};

const EMAIL_SERVICE_KEY = "service_b3md4gt";
const EMAIL_TEMPLATE_ID = "template_o2swg7x";
const EMAIL_PUBLIC_KEY = "QlJpUryIPR7f5c7_6";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://pkmhpk0lgi.execute-api.us-east-2.amazonaws.com";
const STRIPE_CUSTOM_DEVELOPMENT_PAYMENT_LINK =
    process.env.REACT_APP_STRIPE_CUSTOM_DEVELOPMENT_PAYMENT_LINK || "https://buy.stripe.com/28EbJ32Rx3vi7HUfXd8k800";
const STRIPE_SESSION_STATUS_URL = `${API_BASE_URL}/stripe/session-status`;
const STRIPE_CREATE_SUBSCRIPTION_SESSION_URL = `${API_BASE_URL}/create-subscription-session`;
const STRIPE_PRICE_FRONTEND = process.env.REACT_APP_STRIPE_PRICE_FRONTEND || "price_1SNfPHRrlHzLLdRr5g8OgcF7";
const STRIPE_PRICE_FULLSTACK = process.env.REACT_APP_STRIPE_PRICE_FULLSTACK || "price_1SNfPkRrlHzLLdRroJyiUh14";
const STRIPE_PRICE_WEBAPP = process.env.REACT_APP_STRIPE_PRICE_WEBAPP || "price_1SNfQ8RrlHzLLdRrzVVHsce1";
const DOCUMENT_AGENT_API_BASE_URL = (process.env.REACT_APP_DOCUMENT_AGENT_API_BASE_URL || "http://localhost:5212").replace(/\/$/, "");

if (process.env.NODE_ENV === "production" && !process.env.REACT_APP_DOCUMENT_AGENT_API_BASE_URL) {
    // eslint-disable-next-line no-console
    console.error(
        "REACT_APP_DOCUMENT_AGENT_API_BASE_URL is not set. This production build is falling back to " +
        "http://localhost:5212 for the document chat API, which will not work for deployed users. " +
        "Set REACT_APP_DOCUMENT_AGENT_API_BASE_URL at build time."
    );
}

const AGENT_CHAT_API_URL = `${DOCUMENT_AGENT_API_BASE_URL}/agent/chat`;
const DOCUMENT_UPLOAD_API_URL = `${DOCUMENT_AGENT_API_BASE_URL}/storage/upload`;
const DOCUMENT_CLEAR_API_URL = `${DOCUMENT_AGENT_API_BASE_URL}/storage/clear`;

export { 
    rippleEffectDuration,
    toastifyConfigs,
    EMAIL_SERVICE_KEY,
    EMAIL_TEMPLATE_ID,
    EMAIL_PUBLIC_KEY,
    API_BASE_URL,
    STRIPE_CUSTOM_DEVELOPMENT_PAYMENT_LINK,
    STRIPE_SESSION_STATUS_URL,
    STRIPE_CREATE_SUBSCRIPTION_SESSION_URL,
    STRIPE_PRICE_FRONTEND,
    STRIPE_PRICE_FULLSTACK,
    STRIPE_PRICE_WEBAPP,
    DOCUMENT_AGENT_API_BASE_URL,
    AGENT_CHAT_API_URL,
    DOCUMENT_UPLOAD_API_URL,
    DOCUMENT_CLEAR_API_URL,
};
